import React from 'react';
import { Spin } from 'antd';
import { string } from 'prop-types';

const Loading = ({ align = 'center' }) => (
  // Using delay 3000ms to avoid visual flattering.
  // Spinner should appear only on very slow internet.
  <div id="suspense-fallback-spinner" style={{ textAlign: align }}>
    <Spin delay={3000} />
  </div>
);

Loading.propTypes = {
  align: string,
};

export default Loading;
